// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"ee8ff135","494":"64bcbab0","705":"ff10df89","787":"740402f1","954":"b0fc8d29"}[chunkId] + ".chunk.js";
};